import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';

import { Text, Icon } from 'components/atoms';

const TypeIcon = ({ type }) => {
  const ComputedIcon = useMemo(() => {
    if (type === 'success') return () => <Icon icon="check_circle" color="#91d200" />;
    if (type === 'error') return () => <Icon icon="cancel" color="#c34545" />;
    if (type === 'warn') return () => <Icon icon="warn" color="#ffc200" />;
    if (type === 'info') return () => <Icon icon="info" color="#007fe6" />;
    return () => <Icon icon="info" color="#007fe6" />;
  }, [type]);

  return (
    <IconWrapper>
      <ComputedIcon />
    </IconWrapper>
  );
};

TypeIcon.propTypes = {
  type: PropTypes.oneOf(['success', 'error', 'info', 'warn']),
};

TypeIcon.defaultProps = {
  type: 'info',
};

const Toast = ({ type, title, description }) => (
  <Wrapper>
    <TypeIcon type={type} />
    <div>
      <Text modifiers={['weightBase']}>{title}</Text>
      <Text
        modifiers={['lighter', 'xs', 'weightBase']}
        className="toast-description"
      >
        {description}
      </Text>
    </div>
  </Wrapper>
);

Toast.propTypes = {
  type: PropTypes.oneOf(['success', 'error', 'info', 'warn']),
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
};

Toast.defaultProps = {
  type: 'info',
  description: '',
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  .toast-description {
    padding-top: ${props => props.theme.spacing.xs4};
    line-height: ${props => props.theme.spacing.sm};
  }
`;

const IconWrapper = styled.div`
  margin-right: ${props => props.theme.spacing.xs};
`;

export default Toast;
